import React, { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { apiGetJson as apiGet } from '../../../utils/api';

const SCOPES = [['all', 'All'], ['umbrella', 'Umbrellas'], ['standalone', 'Standalone']];

export default function PortfolioCompanyList({ year, selectedId, onSelect }) {
  const [q, setQ] = useState('');
  const [scope, setScope] = useState('all');
  const [mine, setMine] = useState(false);

  const { data, isLoading } = useQuery({
    queryKey: ['portfolio-companies', q, scope, year, mine],
    queryFn: () => apiGet(`/admin/audit_tracker/portfolio/companies?year=${year}&scope=${scope}&mine=${mine}&q=${encodeURIComponent(q)}`),
  });
  const companies = data?.companies || [];

  return (
    <div className="flex flex-col h-full">
      <input
        value={q}
        onChange={(e) => setQ(e.target.value)}
        placeholder="Search companies…"
        className="px-3 py-2 border border-gray-300 dark:border-gray-600 rounded text-sm bg-white dark:bg-gray-800 dark:text-white mb-2"
      />
      <div className="flex flex-wrap gap-1 mb-2">
        {SCOPES.map(([val, label]) => (
          <button
            key={val}
            onClick={() => setScope(val)}
            className={`px-2 py-1 rounded text-xs ${scope === val ? 'bg-blue-600 text-white' : 'bg-gray-100 dark:bg-gray-700 dark:text-gray-200'}`}
          >
            {label}
          </button>
        ))}
        <button
          onClick={() => setMine((m) => !m)}
          className={`px-2 py-1 rounded text-xs ${mine ? 'bg-orange-500 text-white' : 'bg-gray-100 dark:bg-gray-700 dark:text-gray-200'}`}
          title="Companies you lead or have assigned properties in"
        >
          Assigned to me
        </button>
      </div>
      <div className="flex-1 overflow-y-auto divide-y divide-gray-200 dark:divide-gray-700">
        {isLoading && <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-blue-500 m-3" />}
        {!isLoading && companies.length === 0 && (
          <div className="text-gray-500 dark:text-gray-400 py-6 text-center text-sm">No companies found.</div>
        )}
        {companies.map((c) => (
          <button
            key={c.id}
            onClick={() => onSelect(c.id)}
            className={`w-full text-left px-3 py-2 ${selectedId === c.id ? 'bg-blue-50 dark:bg-gray-800' : 'hover:bg-gray-50 dark:hover:bg-gray-700'}`}
          >
            <div className="font-medium text-sm dark:text-gray-100 flex items-center gap-2">
              {c.name || `Company #${c.id}`}
              {c.provisioned && <span className="px-1.5 py-0.5 rounded text-[10px] bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200">provisioned</span>}
            </div>
            <div className="text-xs text-gray-500 dark:text-gray-400">
              {c.state || '-'} · {c.is_umbrella ? `${c.child_count} children` : 'Standalone'} · {c.property_count} properties
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
